/* eslint-disable max-len */
import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';

const w8ben = {
  FormChoiceTitle: <div className="text-center">
    <div>
      Form <br />
      <span style={ { fontSize: '1rem' } }><strong>W-8BEN</strong></span>
    </div>
    <div className="bottom-pad">(Rev. July 2017)</div>
    <div className="bottom-pad">Certificate of Foreign Status of Beneficial Owner for United States Tax Withholding and Reporting (Individuals)</div>
  </div>,
  FormChoiceContent: <div className="content">
    <div>
      <ul>
        <li className="instructions">For use by individuals. Entities must use Form W-8BEN-E.</li>
        <li className="instructions">Go to <a href="http://www.irs.gov/FormW8BEN" target="_blank" rel="noopener noreferrer"><em>www.irs.gov/FormW8BEN</em></a> for instructions and the latest information.</li>
        <li className="instructions">Give this form to the withholding agent or payer. Do not send to the IRS.</li>
      </ul>
    </div>
    <div className="allign-center bottom-pad"> _________________________ </div>
    <div>
      <div><strong>Do NOT use this form if:</strong></div>
      <div>
        <ul>
          <li>You are NOT an individual..... use form W-8BEN-E.</li>
          <li>You are a U.S. citizen or other U.S. person, including a resident alien individual..... use form W-9.</li>
          <li>You are a beneficial owner claiming that income is effectively connected with the conduct of trade or business within the U.S. (other than personal services)..... use form W-8ECI.</li>
          <li>You are a beneficial owner who is receiving compensation for personal services performed in the United States..... use form 8233 or W-4.</li>
          <li>You are a person acting as an intermediary..... use form W-8IMY.</li>
        </ul>
      </div>
    </div>
    <div>
      <strong>Note:</strong> If you are resident in a FATCA partner jurisdiction (i.e., a Model 1 IGA jurisdiction with reciprocity), certain tax account information may be provided to your jurisdiction of residence.
    </div>
  </div>,
  CertificationContent: <div className="content">
    <h3 className="underline">Electronic Signature Consent</h3>
    <span><FormattedHTMLMessage id="certification.electronicSignatureConsent" /></span>
    <h3 className="underline">Part III Certification</h3>
    <span>Under penalties of perjury, I declare that I have examined the information on this form and to the best of my knowledge and belief it is true, correct, and complete. I further certify under penalties of perjury that:</span>
    <ul>
      <li>I am the individual that is the beneficial owner (or am authorized to sign for the individual that is the beneficial owner) of all the income to which this form relates or am using this form to document myself for chapter 4 purposes</li>
      <li>The person named on line 1 of this form is not a U.S. person</li>
      <li>The income to which this form relates is:
        <ol className="latin-list">
          <li>not effectively connected with the conduct of a trade or business in the United States,</li>
          <li>effectively connected but is not subject to tax under an applicable income tax treaty, or</li>
          <li>the partner&apos;s share of a partnership`s effectively connected income</li>
        </ol>
      </li>
      <li>The person named on line 1 of this form is a resident of the treaty country listed on line 9 of the form (if any) within the meaning of the income tax treaty between the United States and that country, and</li>
      <li>For broker transactions or barter exchanges, the beneficial owner is an exempt foreign person as defined in the instructions.</li>
    </ul>
    <br />
    <span>Furthermore, I authorize this form to be provided to any withholding agent that has control, receipt, or custody of the income of which I am the beneficial owner or any withholding agent that can disburse or make payments of the income of which I am the beneficial owner.</span>
    <br /><br />
    <span>
      <strong>I agree that I will submit a new form within 30 days if any certification made on this form becomes incorrect.</strong>
    </span>
  </div>
};
const w8ben2021 = {
  FormChoiceTitle: <div className="text-center">
    <div>
      Form <br />
      <span style={ { fontSize: '1rem' } }><strong>W-8BEN</strong></span>
    </div>
    <div className="bottom-pad">(Rev. Oct 2021)</div>
    <div className="bottom-pad">Certificate of Foreign Status of Beneficial Owner for United States Tax Withholding and Reporting (Individuals)</div>
  </div>,
  FormChoiceContent: <div className="content">
    <div>
      <ul>
        <li className="instructions">For use by individuals. Entities must use Form W-8BEN-E.</li>
        <li className="instructions">Go to <a href="http://www.irs.gov/FormW8BEN" target="_blank" rel="noopener noreferrer"><em>www.irs.gov/FormW8BEN</em></a> for instructions and the latest information.</li>
        <li className="instructions">Give this form to the withholding agent or payer. Do not send to the IRS.</li>
      </ul>
    </div>
    <div className="allign-center bottom-pad"> _________________________ </div>
    <div>
      <div><strong>Do NOT use this form if:</strong></div>
      <div>
        <ul>
          <li>You are NOT an individual..... use form W-8BEN-E.</li>
          <li>You are a U.S. citizen or other U.S. person, including a resident alien individual..... use form W-9.</li>
          <li>You are a beneficial owner claiming that income is effectively connected with the conduct of trade or business within the United States (other than personal services)..... use form W-8ECI.</li>
          <li>You are a beneficial owner who is receiving compensation for personal services performed in the United States..... use form 8233 or W-4.</li>
          <li>You are a person acting as an intermediary..... use form W-8IMY.</li>
        </ul>
      </div>
    </div>
    <div>
      <strong>Note:</strong> If you are resident in a FATCA partner jurisdiction (that is, a Model 1 IGA jurisdiction with reciprocity), certain tax account information may be provided to your jurisdiction of residence.
    </div>
  </div>,
  CertificationContent: <div className="content">
    <h3 className="underline">Electronic Signature Consent</h3>
    <span><FormattedHTMLMessage id="certification.electronicSignatureConsent" /></span>
    <h3 className="underline">Part III Certification</h3>
    <span>Under penalties of perjury, I declare that I have examined the information on this form and to the best of my knowledge and belief it is true, correct, and complete. I further certify under penalties of perjury that:</span>
    <ul>
      <li>I am the individual that is the beneficial owner (or am authorized to sign for the individual that is the beneficial owner) of all the income or proceeds to which this form relates or am using this form to document myself for chapter 4 purposes,</li>
      <li>The person named on line 1 of this form is not a U.S. person,</li>
      <li>
        This form relates to:
        <ol className="latin-list">
          <li>income not effectively connected with the conduct of a trade or business in the United States;</li>
          <li>income effectively connected with the conduct of a trade or business in the United States but is not subject to tax under an applicable income tax treaty;</li>
          <li>the partner’s share of a partnership’s effectively connected taxable income; or</li>
          <li>the partner’s amount realized from the transfer of a partnership interest subject to withholding under section 1446(f);</li>
        </ol>
      </li>
      <li>The person named on line 1 of this form is a resident of the treaty country listed on line 9 of the form (if any) within the meaning of the income tax treaty between the United States and that country, and</li>
      <li>For broker transactions or barter exchanges, the beneficial owner is an exempt foreign person as defined in the instructions.</li>
    </ul>
    <br />
    <span>Furthermore, I authorize this form to be provided to any withholding agent that has control, receipt, or custody of the income of which I am the beneficial owner or any withholding agent that can disburse or make payments of the income of which I am the beneficial owner.</span>
    <br /><br />
    <span>
      <strong>I agree that I will submit a new form within 30 days if any certification made on this form becomes incorrect</strong>
    </span>
  </div>
};
const w8bene2017 = {
  FormChoiceTitle: <div className="text-center">
    <div>
      Form <br />
      <span style={ { fontSize: '1rem' } }><strong>W-8BEN-E</strong></span>
    </div>
    <div className="bottom-pad">(Rev. July 2017)</div>
    <div className="bottom-pad">Certificate of Status of Beneficial Owner for United States Tax Withholding and Reporting (Entities)</div>
  </div>,
  FormChoiceContent: <div className="content">
    <div>
      <ul>
        <li className="instructions">For use by entities. Individuals must use Form W-8BEN.</li>
        <li className="instructions">Section references are to the Internal Revenue Code.</li>
        <li className="instructions">Go to <a href="http://www.irs.gov/FormW8BENE" target="_blank" rel="noopener noreferrer"><em>www.irs.gov/FormW8BENE</em></a> for instructions and the latest information.</li>
        <li className="instructions">Give this form to the withholding agent or payer. Do not send to the IRS.</li>
      </ul>
    </div>
    <div className="allign-center bottom-pad"> _________________________ </div>
    <div>
      <div><strong>Do NOT use this form if:</strong></div>
      <div>
        <ul>
          <li>U.S. entity or U.S. citizen or resident..... use form W-9.</li>
          <li>A foreign individual..... use formW-8BEN (Individual) or Form 8233.</li>
          <li>A foreign individual or entity claiming that income is effectively connected with the conduct of trade or business within the U.S. (unless claiming treaty benefits)..... use form W-8ECI.</li>
          <li>A foreign partnership, a foreign simple trust, or a foreign grantor trust (unless claiming treaty benefits) (see instructions for exceptions)..... use form W-8IMY</li>
          <li>A foreign government, international organization, foreign central bank of issue, foreign tax-exempt organization, foreign private foundation, or government of a U.S. possession claiming that income is effectively connected U.S. income or that is claiming the applicability of section(s) 115(2), 501(c), 892, 895, or 1443(b) (unless claiming treaty benefits) (see instructions for other exceptions)..... use form W-8ECI or W-8EXP.</li>
          <li>Any person acting as an intermediary..... use form W-8IMY.</li>
        </ul>
      </div>
    </div>
  </div>,
  CertificationContent: <div className="content">
    <h3 className="underline">Electronic Signature Consent</h3>
    <span><FormattedHTMLMessage id="certification.electronicSignatureConsent" /></span>
    <h3 className="underline">Part XXX Certification</h3>
    <span>Under penalties of perjury, I declare that I have examined the information on this form and to the best of my knowledge and belief it is true, correct, and complete. I further certify under penalties of perjury that:</span>
    <ul>
      <li>The entity identified on line 1 of this form is the beneficial owner of all the income to which this form relates, is using this form to certify its status for chapter 4 purposes, or is a merchant submitting this form for purposes of section 6050W;</li>
      <li>The entity identified on line 1 of this form is not a U.S. person;</li>
      <li>The income to which this form relates is:
        <ol className="latin-list">
          <li>not effectively connected with the conduct of a trade or business in the United States,</li>
          <li>effectively connected but is not subject to tax under an applicable income tax treaty, or</li>
          <li>the partner&apos;s share of a partnership`s effectively connected income; <strong>and</strong></li>
        </ol>
      </li>
      <li>For broker transactions or barter exchanges, the beneficial owner is an exempt foreign person as defined in the instructions.</li>
    </ul>
    <br />
    <span>Furthermore, I authorize this form to be provided to any withholding agent that has control, receipt, or custody of the income of which the entity on line 1 is the beneficial owner or any withholding agent that can disburse or make payments of the income of which the entity on line 1 is the beneficial owner.</span>
    <br /><br />
    <span>
      <strong>I agree that I will submit a new form within 30 days if any certification made on this form becomes incorrect.</strong>
    </span>
  </div>
};
const w8bene2021 = {
  FormChoiceTitle: <div className="text-center">
    <div>
      Form <br />
      <span style={ { fontSize: '1rem' } }><strong>W-8BEN-E</strong></span>
    </div>
    <div className="bottom-pad">(Rev. Oct 2021)</div>
    <div className="bottom-pad">Certificate of Status of Beneficial Owner for United States Tax Withholding and Reporting (Entities)</div>
  </div>,
  FormChoiceContent: <div className="content">
    <div>
      <ul>
        <li className="instructions">For use by entities. Individuals must use Form W-8BEN.</li>
        <li className="instructions">Section references are to the Internal Revenue Code.</li>
        <li className="instructions">Go to <a href="http://www.irs.gov/FormW8BENE" target="_blank" rel="noopener noreferrer"><em>www.irs.gov/FormW8BENE</em></a> for instructions and the latest information.</li>
        <li className="instructions">Give this form to the withholding agent or payer. Do not send to the IRS.</li>
      </ul>
    </div>
    <div className="allign-center bottom-pad"> _________________________ </div>
    <div>
      <div><strong>Do NOT use this form if:</strong></div>
      <div>
        <ul>
          <li>U.S. entity or U.S. citizen or resident..... use form W-9.</li>
          <li>A foreign individual..... use formW-8BEN (Individual) or Form 8233.</li>
          <li>A foreign individual or entity claiming that income is effectively connected with the conduct of trade or business within the United States (unless claiming treaty benefits)..... use form W-8ECI.</li>
          <li>A foreign partnership, a foreign simple trust, or a foreign grantor trust (unless claiming treaty benefits) (see instructions for exceptions)..... use form W-8IMY</li>
          <li>A foreign government, international organization, foreign central bank of issue, foreign tax-exempt organization, foreign private foundation, or government of a U.S. possession claiming that income is effectively connected U.S. income or that is claiming the applicability of section(s) 115(2), 501(c), 892, 895, or 1443(b) (unless claiming treaty benefits) (see instructions for other exceptions)..... use form W-8ECI or W-8EXP.</li>
          <li>Any person acting as an intermediary..... use form W-8IMY.</li>
        </ul>
      </div>
    </div>
  </div>,
  CertificationContent: <div className="content">
    <h3 className="underline">Electronic Signature Consent</h3>
    <span><FormattedHTMLMessage id="certification.electronicSignatureConsent" /></span>
    <h3 className="underline">Part XXX Certification</h3>
    <span>Under penalties of perjury, I declare that I have examined the information on this form and to the best of my knowledge and belief it is true, correct, and complete. I further certify under penalties of perjury that:</span>
    <ul>
      <li>The entity identified on line 1 of this form is the beneficial owner of all the income or proceeds to which this form relates, is using this form to certify its status for chapter 4 purposes, or is submitting this form for purposes of section 6050W or 6050Y;</li>
      <li>The entity identified on line 1 of this form is not a U.S. person;</li>
      <li>This form relates to:
        <ol className="latin-list">
          <li>income not effectively connected with the conduct of a trade or business in the United States,</li>
          <li>income effectively connected with the conduct of a trade or business in the United States but is not subject to tax under an income tax treaty,</li>
          <li>the partner&apos;s share of a partnership&apos;s effectively connected income, or</li>
          <li>the partner&apos;s amount realized from the transfer of a partnership interest subject to withholding under section 1446(f); <strong>and</strong></li>
        </ol>
      </li>
      <li>For broker transactions or barter exchanges, the beneficial owner is an exempt foreign person as defined in the instructions.</li>
    </ul>
    <br />
    <span>Furthermore, I authorize this form to be provided to any withholding agent that has control, receipt, or custody of the income of which the entity on line 1 is the beneficial owner or any withholding agent that can disburse or make payments of the income of which the entity on line 1 is the beneficial owner.</span>
    <br /><br />
    <span>
      <strong>I agree that I will submit a new form within 30 days if any certification made on this form becomes incorrect.</strong>
    </span>
  </div>
};
function w92018(subjectToBackupWithholding) {
  return {
    FormChoiceTitle: <div className="text-center">
      <div>
        Form <br />
        <span style={ { fontSize: '1rem' } }><strong>W-9</strong></span>
      </div>
      <div>(Rev. October 2018)</div>
      <div>Request for Taxpayer Identification Number and Certification</div>
    </div>,
    FormChoiceContent: <div className="content">
      <div>
        <ul>
          <li className="instructions">Go to <a href="http://www.irs.gov/FormW9" target="_blank" rel="noopener noreferrer"><em>www.irs.gov/FormW9</em></a> for instructions and the latest information.</li>
        </ul>
      </div>
    </div>,
    CertificationContent: <div className="content">
      <h3 className="underline">Electronic Signature Consent</h3>
      <span><FormattedHTMLMessage id="certification.electronicSignatureConsent" /></span>
      <h3 className="underline">Part II Certification</h3>
      <span><strong>Under penalties of perjury, I certify that:</strong></span>
      <ol>
        <li>The number shown on this form is my correct taxpayer identification number (or I am waiting for a number to be issued to me); and</li>
        <li className={ subjectToBackupWithholding ? 'text-strike-through' : '' }><strong>I am not subject to backup withholding because: (a) I am exempt from backup withholding, or (b) I have not been notified by the Internal Revenue Service (IRS) that I am subject to backup withholding as a result of a failure to report all interest or dividends, or (c) the IRS has notified me that I am no longer subject to backup withholding; and</strong></li>
        <li>I am a U.S. citizen or other U.S. person (defined below); and</li>
        <li>The FATCA code(s) entered on this form (if any) indicating that I am exempt from FATCA reporting is correct.</li>
      </ol>
      <span><strong>Certification instructions.</strong> You must cross out item 2 above if you have been notified by the IRS that you are currently subject to backup withholding because you have failed to report all interest and dividends on your tax return. For real estate transactions, item 2 does not apply. For mortgage interest paid, acquisition or abandonment of secured property, cancellation of debt, contributions to an individual retirement arrangement (IRA), and generally, payments other than interest and dividends, you are not required to sign the certification, but you must provide your correct TIN. See the instructions for Part II, later.</span>
    </div>
  };
}
const w8imy2017 = {
  FormChoiceTitle: <div className="text-center">
    <div>
      Form <br />
      <span style={ { fontSize: '1rem' } }><strong>W-8IMY</strong></span>
    </div>
    <div className="bottom-pad">(Rev. June 2017)</div>
    <div className="bottom-pad">Certificate of Foreign Intermediary, Foreign Flow-Through Entity, or Certain U.S. Branches for United States Tax Withholding and Reporting</div>
  </div>,
  FormChoiceContent: <div className="content">
    <div>
      <ul>
        <li className="instructions">Section references are to the Internal Revenue Code.</li>
        <li className="instructions">Go to <a href="http://www.irs.gov/FormW8IMY" target="_blank" rel="noopener noreferrer"><em>www.irs.gov/FormW8IMY</em></a> for instructions and the latest information.</li>
        <li className="instructions">Give this form to the withholding agent or payer. Do not send to the IRS.</li>
      </ul>
    </div>
    <div className="allign-center bottom-pad"> _________________________ </div>
    <div>
      <div><strong>Do NOT use this form if:</strong></div>
      <div>
        <ul>
          <li>A beneficial owner solely claiming foreign status or treaty benefits (other than a qualified intermediary (QI) acting as a qualified derivatives dealer (QDD))..... use form W-8BEN or W-8BEN-E.</li>
          <li>A hybrid entity claiming treaty benefits on its own behalf (other than a QI acting as a QDD)..... use form W-8BEN-E.</li>
          <li>A foreign person claiming that income is effectively connected with the conduct of a trade or business in the United States..... use form W-8ECI.</li>
          <li>A disregarded entity with a single foreign owner that is the beneficial owner (other than a QI acting as a QDD) of the income to which this form relates. Instead, the single foreign owner should use..... use form W-8BEN, W-8ECI, or W-8BEN-E</li>
          <li>A foreign government, international organization, foreign central bank of issue, foreign tax-exempt organization, foreign private foundation, or government of a U.S. possession claiming the applicability of section(s) 115(2), 501(c), 892, 895, or 1443(b)..... use form W-8EXP.</li>
          <li>U.S. entity or U.S. citizen or resident..... use form W-9.</li>
          <li>A foreign person documenting itself for purposes of section 6050W..... use form W-8BEN, W-8BEN-E, or W-8ECI.</li>
        </ul>
      </div>
    </div>
  </div>,
  CertificationContent: <div className="content">
    <h3 className="underline">Electronic Signature Consent</h3>
    <span><FormattedHTMLMessage id="certification.electronicSignatureConsent" /></span>
    <h3 className="underline">Part XXIX Certification</h3>
    <span>Under penalties of perjury, I declare that I have examined the information on this form, and to the best of my knowledge and belief, it is true, correct, and complete. Furthermore, I authorize this form to be provided to any withholding agent that has control, receipt, or custody of the income for which I am providing this form or any withholding agent that can disburse or make payments of the amounts for which I am providing this form.</span>
    <br /><br />
    <span><strong>I agree that I will submit a new form within 30 days if any certification made on this form becomes incorrect.</strong></span>
  </div>
};
const w8eci = {
  FormChoiceTitle: <div className="text-center">
    <div>
      Form <br />
      <span style={ { fontSize: '1rem' } }><strong>W-8ECI</strong></span>
    </div>
    <div>(Rev. July 2017)</div>
    <div className="bottom-pad">Certificate of Foreign Person&apos;s Claim That Income Is Effectively Connected With the Conduct of a Trade or Business in the United States</div>
  </div>,
  FormChoiceContent: <div className="content">
    <div>
      <ul>
        <li className="instructions">Section references are to the Internal Revenue Code.</li>
        <li className="instructions">Go to <a href="http://www.irs.gov/FormW8ECI" target="_blank" rel="noopener noreferrer"><em>www.irs.gov/FormW8ECI</em></a> for instructions and the latest information.</li>
        <li className="instructions">Give this form to the withholding agent or payer. Do not send to the IRS.</li>
      </ul>
    </div>
    <div style={ { paddingTop: '0.5rem' } }>
      <strong>Note.</strong>&nbsp;<em>Persons submitting this form must file an annual U.S. income tax return to report income claimed to be effectively connected with a U.S. trade or business (see instructions).</em>
    </div>
    <div className="allign-center bottom-pad"> _________________________ </div>
    <div>
      <div><strong>Do NOT use this form if:</strong></div>
      <div>
        <ul>
          <li>A beneficial owner solely claiming foreign status or treaty benefits..... use form W-8BEN or W-8BEN-E.</li>
          <li>A foreign government, international organization, foreign central bank of issue, foreign tax-exempt organization, foreign private foundation, or government of a U.S. possession claiming the applicability of section(s) 115(2), 501(c), 892, 895, or 1443(b)..... use form W-8EXP.</li>
          <div style={ { marginLeft: '1rem', fontSize: '0.7rem' } }>
            <strong>Note.</strong>&nbsp;<em>These entities should use Form W-8ECI if they received effectively connected income and are not eligible to claim an exemption for chapter 3 or 4 purposes on Form W-8EXP.</em>
          </div>
          <li>A foreign partnership or a foreign trust (unless claiming an exemption from U.S. withholding on income effectively connected with the conduct of a trade or business in the United States)..... use form W-8BEN-E or W-8IMY.</li>
          <li>You are a person acting as an intermediary..... use form W-8IMY.</li>
        </ul>
      </div>
      <div>
        <strong>Note.</strong>&nbsp;See instructions for additional exceptions.
      </div>
    </div>
  </div>,
  CertificationContent: <div className="content">
    <h3 className="underline">Electronic Signature Consent</h3>
    <span><FormattedHTMLMessage id="certification.electronicSignatureConsent" /></span>
    <h3 className="underline">Part II Certification</h3>
    <span>Under penalties of perjury, I declare that I have examined the information on this form and to the best of my knowledge and belief it is true, correct, and complete. I further certify under penalties of perjury that:</span>
    <ul>
      <li>I am the beneficial owner (or I am authorized to sign for the beneficial owner) of all the payments to which this form relates,</li>
      <li>The amounts for which this certification is provided are effectively connected with the conduct of a trade or business in the United States,</li>
      <li>The income for which this form was provided is includible in my gross income (or the beneficial owner&apos;s gross income) for the taxable year, <strong>and</strong></li>
      <li>The beneficial owner is not a U.S. person.</li>
    </ul>
    <br />
    <span>Furthermore, I authorize this form to be provided to any withholding agent that has control, receipt, or custody of the payments of which I am the beneficial owner or any withholding agent that can disburse or make payments of the amounts of which I am the beneficial owner.</span>
    <br /><br />
    <span>
      <strong>I agree that I will submit a new form within 30 days if any certification made on this form becomes incorrect.</strong>
    </span>
  </div>
};
const w8eci2021 = {
  FormChoiceTitle: <div className="text-center">
    <div>
      Form <br />
      <span style={ { fontSize: '1rem' } }><strong>W-8ECI</strong></span>
    </div>
    <div>(Rev. Oct 2021)</div>
    <div className="bottom-pad">Certificate of Foreign Person&apos;s Claim That Income Is Effectively Connected With the Conduct of a Trade or Business in the United States</div>
  </div>,
  FormChoiceContent: <div className="content">
    <div>
      <ul>
        <li className="instructions">Section references are to the Internal Revenue Code.</li>
        <li className="instructions">Go to <a href="http://www.irs.gov/FormW8ECI" target="_blank" rel="noopener noreferrer"><em>www.irs.gov/FormW8ECI</em></a> for instructions and the latest information.</li>
        <li className="instructions">Give this form to the withholding agent or payer. Do not send to the IRS.</li>
      </ul>
    </div>
    <div style={ { paddingTop: '0.5rem' } }>
      <strong>Note.</strong>&nbsp;<em>Persons submitting this form must file an annual U.S. income tax return to report income claimed to be effectively connected with a U.S. trade or business (see instructions).</em>
    </div>
    <div className="allign-center bottom-pad"> _________________________ </div>
    <div>
      <div><strong>Do NOT use this form if:</strong></div>
      <div>
        <ul>
          <li>A beneficial owner solely claiming foreign status or treaty benefits..... use form W-8BEN or W-8BEN-E.</li>
          <li>A foreign government, international organization, foreign central bank of issue, foreign tax-exempt organization, foreign private foundation, or government of a U.S. possession claiming the applicability of section(s) 115(2), 501(c), 892, 895, or 1443(b)..... use form W-8EXP.</li>
          <div style={ { marginLeft: '1rem', fontSize: '0.7rem' } }>
            <strong>Note.</strong>&nbsp;<em>These entities should use Form W-8ECI if they received effectively connected income and are not eligible to claim an exemption for chapter 3 or 4 purposes on Form W-8EXP.</em>
          </div>
          <li>A foreign partnership or a foreign trust (unless claiming an exemption from U.S. withholding on income effectively connected with the conduct of a trade or business in the United States)..... use form W-8BEN-E or W-8IMY.</li>
          <li>You are a person acting as an intermediary..... use form W-8IMY.</li>
        </ul>
      </div>
      <div>
        <strong>Note.</strong>&nbsp;See instructions for additional exceptions.
      </div>
    </div>
  </div>,
  CertificationContent: <div className="content">
    <h3 className="underline">Electronic Signature Consent</h3>
    <span><FormattedHTMLMessage id="certification.electronicSignatureConsent" /></span>
    <h3 className="underline">Part II Certification</h3>
    <span>Under penalties of perjury, I declare that I have examined the information on this form and to the best of my knowledge and belief it is true, correct, and complete. I further certify under penalties of perjury that:</span>
    <ul>
      <li>I am the beneficial owner (or I am authorized to sign for the beneficial owner) of all the payments to which this form relates,</li>
      <li>The amounts for which this certification is provided are effectively connected with the conduct of a trade or business in the United States,</li>
      <li>The income for which this form was provided is includible in my gross income (or the beneficial owner&apos;s gross income) for the taxable year, <strong>and</strong></li>
      <li>The beneficial owner is not a U.S. person.</li>
    </ul>
    <br />
    <span>Furthermore, I authorize this form to be provided to any withholding agent that has control, receipt, or custody of the payments of which I am the beneficial owner or any withholding agent that can disburse or make payments of the amounts of which I am the beneficial owner.</span>
    <br /><br />
    <span>
      <strong>I agree that I will submit a new form within 30 days if any certification made on this form becomes incorrect.</strong>
    </span>
  </div>
};
const w8exp = {
  FormChoiceTitle: <div className="text-center">
    <div>
      Form <br />
      <span style={ { fontSize: '1rem' } }><strong>W-8EXP</strong></span>
    </div>
    <div>(Rev. July 2017)</div>
    <div>Certificate of Foreign Government or Other Foreign<br />Organization for United States Tax<br />Withholding and Reporting</div>
  </div>,
  FormChoiceContent: <div className="content">
    <p style={ { fontSize: '0.7rem' } }><strong>For use by foreign governments, international organizations, foreign central banks of issue, foreign tax-exempt organizations, foreign private foundations, and governments of U.S. possessions.</strong></p>
    <div>
      <ul>
        <li className="instructions">Information about Form W-8EXP and its separate instructions is at <a href="http://www.irs.gov/formw8exp" target="_blank" rel="noopener noreferrer"><em>www.irs.gov/formw8exp</em></a>.</li>
        <li className="instructions">Section references are to the Internal Revenue Code. </li>
        <li className="instructions">Give this form to the withholding agent or payer. Do not send to the IRS.</li>
      </ul>
    </div>
    <div className="allign-center bottom-pad"> _________________________ </div>
    <div>
      <div><strong>Do NOT use this form if:</strong></div>
      <div>
        <ul>
          <li>A foreign government or other foreign organization that is not claiming the applicability of section(s) 115(2), 501(c), 892, 895, or 1443(b)..... use form W-8BEN-E or W-8ECI.</li>
          <li>A beneficial owner solely claiming foreign status or treaty benefits..... use form W-8BEN or W-8BEN-E.</li>
          <li>A foreign partnership or a foreign trust..... use form W-8BEN-E or W-8IMY.</li>
          <li>A person claiming that income is effectively connected with the conduct of a trade or business in the United States..... use form W-8ECI.</li>
          <li>You are a person acting as an intermediary..... use form W-8IMY.</li>
        </ul>
      </div>
    </div>
    <div>
      <strong>Note:</strong> If you are resident in a FATCA partner jurisdiction (i.e., a Model 1 IGA jurisdiction with reciprocity), certain tax account information may be provided to your jurisdiction of residence.
    </div>
  </div>,
  CertificationContent: <div className="content">
    <h3>Electronic Signature Consent</h3>
    <span><FormattedHTMLMessage id="certification.electronicSignatureConsent" /></span>
    <h3 className="underline">Part IV Certification</h3>
    <span>Under penalties of perjury, I declare that I have examined the information on this form and to the best of my knowledge and belief it is true, correct, and complete. I further certify under penalties of perjury that:</span>
    <ul>
      <li>The organization for which I am signing is the beneficial owner of the income and other payments to which this form relates,</li>
      <li>The beneficial owner is not a U.S. person,</li>
      <li>For a beneficial owner that is a controlled entity of a foreign sovereign (other than a central bank of issue wholly owned by a foreign sovereign), the beneficial owner is not engaged in commercial activities within or outside the United States, <strong>and</strong></li>
      <li>For a beneficial owner that is a central bank of issue wholly owned by a foreign sovereign, the beneficial owner is not engaged in commercial activities within the United States.</li>
    </ul>
    <br />
    <span>Furthermore, I authorize this form to be provided to any withholding agent that has control, receipt, or custody of the payments of which I am the beneficial owner or any withholding agent that can disburse or make payments of the amounts of which I am the beneficial owner.</span>
    <br /><br />
    <span>
      <strong>I agree that I will submit a new form within 30 days if any certification made on this form becomes incorrect.</strong>
    </span>
  </div>
};
const crsi = {
  FormChoiceTitle: <div>
    <div>
      <span style={ { fontSize: '1.5rem' } }><strong>CRS-I</strong></span>
    </div>
    <div>CRS Individual Self-Certification Form</div>
  </div>,
  FormChoiceContent: <div className="content">
    <p><strong>Who should complete the CRS Individual Self-Certification Form?</strong></p>
    <p>Personal banking customers or sole traders should complete this form.</p>
    <p>If you need to self-certify on behalf of an entity (which includes businesses, trusts and partnerships), complete an &apos;Entity Tax Residency Self-Certification Form&apos; (CRS-E). Similarly, if you are a controlling person of an entity, complete a &apos;Controlling Person Tax Residency Self-Certification Form&apos; (CRS-CP).</p>
    <p>For joint account holders, each individual will need to complete a copy of the form.</p>
    <p>Even if you have already provided information in relation to the United States Government&apos;s Foreign Account Tax Compliance Act (FATCA), you may still need to provide additional information for the CRS as this is a separate regulation.</p>
    <p>If you are completing this form on behalf of someone else, please ensure that you let them know that you have done so and tell us in what capacity you are signing in Part 3. For example, you might be completing this form as a custodian or nominee of an account, under a Power of Attorney or as a legal guardian on behalf of an account holder who is a minor.</p>
  </div>,
  CertificationContent: <div className="content">
    <h3 className="underline">Electronic Signature Consent</h3>
    <span><FormattedHTMLMessage id="certification.electronicSignatureConsent" /></span>
    <h3 className="underline">Form Declaration</h3>
    <p><strong>I declare that all statements made in this declaration are, to the best of my knowledge and belief, correct and complete.</strong></p>
    <p>I undertake to advise the requester of this form within 30 days of any change in circumstances which affects the tax residency status of the individual identified in Part 1 of this form or causes the information contained herein to become incorrect, and to provide the requester of this form with a suitably updated self-certification and Declaration within 90 days of such change in circumstances.</p>
  </div>
};
const crse = {
  FormChoiceTitle: <div>
    <div>
      <span style={ { fontSize: '1.5rem' } }><strong>CRS-E</strong></span>
    </div>
    <div>CRS Entity Self-Certification Form</div>
  </div>,
  FormChoiceContent: <div className="content">
    <p><strong>Who should complete the CRS Entity Self-Certification Form?</strong></p>
    <p>Business banking customers (which includes all businesses, trusts and partnerships except sole traders) should complete this form.</p>
    <p>If you are a personal banking customer or a sole trader complete an &apos;Individual Tax Residency Self-Certification Form&apos; (CRS-I). Similarly, if you are a controlling person of an entity, complete a &apos;Controlling Person Tax Residency Self-Certification Form&apos; (CRS-CP).</p>
    <p>For joint account holders, a copy of the form should be completed for each account holder.</p>
    <p>Even if you have already provided information in relation to the United States Government&apos;s Foreign Account Tax Compliance Act (FATCA), you may still need to provide additional information for the CRS as this is a separate regulation.</p>
    <p>Please tell us in what capacity you are signing in Part 4. For example you may be an authorised officer of the business or a trustee.</p>
  </div>,
  CertificationContent: <div className="content">
    <h3 className="underline">Electronic Signature Consent</h3>
    <span><FormattedHTMLMessage id="certification.electronicSignatureConsent" /></span>
    <h3 className="underline">Form Declaration</h3>
    <p><strong>I declare that all statements made in this declaration are, to the best of my knowledge and belief, correct and complete.</strong></p>
    <p>I undertake to advise the requester of this form within 30 days of any change in circumstances which affects the tax residency status of the Account Holder identified in Part 1 of this form or causes the information contained herein to become incorrect (including any changes to the information on controlling persons identified in Part 2 question 2a), and to provide the requester of this form a suitably updated self-certification and Declaration within 90 days of such change in circumstances.</p>
  </div>
};
const crscp = {
  FormChoiceTitle: <div>
    <div>
      <span style={ { fontSize: '1.5rem' } }><strong>CRS-CP</strong></span>
    </div>
    <div>CRS Controlling Person Self-Certification Form</div>
  </div>,
  FormChoiceContent: <div className="content">
    <p><strong>Who should complete the CRS Controlling Person Self-Certification Form?</strong></p>
    <p>When an account is held with the requester of this form on behalf of a Passive Entity (for example certain trusts or investment vehicles) we need those individuals identified as having ultimate control of the entity to complete a form. These individuals are termed &apos;controlling persons&apos;.</p>
    <p>If you need to self-certify on behalf of an entity (which includes all businesses, trusts and partnerships), complete an &apos;Entity Tax Residency Self-Certification Form&apos; (CRS-E).</p>
    <p>For joint or multiple controlling persons each individual will need to complete a copy of the form.</p>
    <p>Even if you have already provided information in relation to the United States Government&apos;s Foreign Account Tax Compliance Act (FATCA), you may still need to provide additional information for the CRS as this is a separate regulation.</p>
    <p>If you are completing this form on behalf of a controlling person, please ensure that you let them know that you have done so and tell us in what capacity you are signing in Part 4. For example you may be a representative of the entity, or completing the form under a power of attorney.</p>
  </div>,
  CertificationContent: <div className="content">
    <h3 className="underline">Electronic Signature Consent</h3>
    <span><FormattedHTMLMessage id="certification.electronicSignatureConsent" /></span>
    <h3 className="underline">Form Declaration</h3>
    <p><strong>I declare that all statements made in this declaration are, to the best of my knowledge and belief, correct and complete.</strong></p>
    <p>I undertake to advise the requester of this form within 30 days of any change in circumstances which affects the tax residency status of the individual identified in Part 1 of this form or causes the information contained herein to become incorrect, and to provide the requester of this form with a suitably updated self-certification and Declaration within 90 days of such change in circumstances.</p>
  </div>
};

const ModalInstructions = (formType, subjectToBackupWithholding) => {
  switch (formType) {
    case 'w9_2018':
      return w92018(subjectToBackupWithholding);
    case 'w8ben':
      return w8ben;
    case 'w8ben_2021':
      return w8ben2021;
    case 'w8bene_2017':
      return w8bene2017;
    case 'w8bene_2021':
      return w8bene2021;
    case 'w8eci':
      return w8eci;
    case 'w8eci_2021':
      return w8eci2021;
    case 'w8exp':
      return w8exp;
    case 'w8imy_2017':
      return w8imy2017;
    case 'crsi':
      return crsi;
    case 'crse':
      return crse;
    case 'crscp':
      return crscp;
    default:
      return null;
  }
};

export default ModalInstructions;
